import { useEffect, useRef } from "react"

import { useTranslation } from "react-i18next"

import { Label } from "@/components/ui/label"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { useCurrentSessionType } from "@/hooks/use-current-session-type"
import { useVideoInsightSettings } from "@/hooks/use-module-settings"
import { useVideoInsightStore } from "@/stores/video-insight-store"

import { languages } from "../config/iso-languages"

export function VideoLanguageSelect() {
  const sessionType = useCurrentSessionType()
  const videoStore = useVideoInsightStore(sessionType)
  const videoLanguage = videoStore((state) => state.videoLanguage)
  const setVideoLanguage = videoStore((state) => state.setVideoLanguage)
  const { settings } = useVideoInsightSettings()
  const hasInitialized = useRef(false)

  const { t } = useTranslation()

  // Initialize video language from database once (optimistic updates prevent DB from overriding UI changes)
  useEffect(() => {
    if (settings?.video_language && !hasInitialized.current) {
      videoStore.setState({ videoLanguage: settings.video_language })
      hasInitialized.current = true
    }
  }, [settings?.video_language, videoStore])

  return (
    <section className="flex flex-col gap-2">
      <Label>{t("pages.video_insight.video_language")}</Label>
      <Select value={videoLanguage} onValueChange={setVideoLanguage}>
        <SelectTrigger>
          <SelectValue placeholder={t("pages.video_insight.select_language")} />
        </SelectTrigger>
        <SelectContent>
          {languages.map((language) => (
            <SelectItem key={language.code} value={language.code}>
              {language.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </section>
  )
}
